

function init() {

	$('.gmap').each(function(i,el) {
		showAddress($(el));
	});

	window.showAddress = ($el) => {
		var $data = $el.find('span');
		var street = $data.attr('data-street');
		var city = $data.attr('data-city');
		var title = $data.attr('data-title');
		var ll = new google.maps.LatLng( $data.attr('data-lat'), $data.attr('data-lng'));
		var map = new google.maps.Map($el.find('.map-canvas')[0],{zoom:15,center:ll,mapTypeId:google.maps.MapTypeId.ROADMAP});
		map.setCenter(ll);
		var marker = new google.maps.Marker({ map: map, position: ll });
		var infoWindow = new google.maps.InfoWindow({content:'<b>'+title+'</b><br>'+street+'<br>'+city});
		infoWindow.open(map,marker);
	}
}
init();
